module.exports = __webpack_public_path__ + "static/gems-14a0139930ba7c01463833a350ec9d07.webp";